// extracted by mini-css-extract-plugin
export default {"userIconWrapper":"LoginIcon_userIconWrapper__d0WAT"};